import { Spinner } from 'react-bootstrap'; 

export default function SpinnerCustom() {
    return (
        <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
                zIndex: 1000,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
            }}>
            <div className="text-center">
                <div className="mb-3" style={{ position: 'relative' }}>
                    <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -55%)',
                        width: '4rem',
                        height: '4rem',
                        border: '2px solid rgba(13, 110, 253, 0.2)',
                        borderRadius: '50%',
                        animation: 'pulse 2s infinite'
                    }}></div>
                </div>
                <div className="text-primary fw-medium">Loading data</div>
                <div className="text-muted small">Please wait a moment...</div>
            </div>
        </div>
    )
}